import { Link } from "react-router-dom";
import styled from "styled-components";

export const FooterSection = styled("footer")`
	background: var(--color-surface);
	padding: 2.5rem 0;
`;

export const Title = styled("h4")`
	font-size: 22px;
	text-transform: capitalize;
	color: var(--color-heading);

	@media screen and (max-width: 414px) {
		padding: 1.5rem 0;
	}
`;

export const NavLink = styled(Link)`
	display: block;
	font-size: 1rem;
	margin-bottom: 0.625rem;
	transition: all 0.2s ease-in-out;

	&:hover,
	&:active,
	&:focus {
		color: var(--color-primary-hover);
	}
`;

export const Extra = styled("section")`
	background: var(--color-surface);
	position: relative;
	width: 100%;
	margin-right: auto;
	margin-left: auto;
	padding-bottom: 2rem;
	box-sizing: border-box;
	overflow-x: hidden;
`;

export const LogoContainer = styled("div")`
	display: flex;
	position: relative;
`;

export const Para = styled("div")`
	color: var(--color-text);
	font-size: 14px;
	width: 70%;
`;

export const Large = styled(Link)`
	font-size: 16px;
	color: var(--color-text);
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	text-transform: capitalize;
	line-height: 24px;
	display: block;
	margin-bottom: 0.625rem;
	transition: all 0.3s ease-in-out;
	max-width: max-content;

	&:hover {
		color: var(--color-primary-hover);
		text-underline-position: under;
		text-decoration: var(--color-primary-hover) wavy underline;
	}
`;

export const Chat = styled("p")`
	color: var(--color-text);
	max-width: fit-content;
	border-bottom: 1px solid var(--color-text);
	cursor: pointer;
	margin-top: 1rem;
	transition: all 0.3s ease-in-out;

	&:hover {
		border-bottom: 1px solid var(--color-primary-hover);
		color: var(--color-primary-hover);
	}
`;

export const Empty = styled("div")`
	position: relative;
	height: 53px;
`;

export const FooterContainer = styled("div")`
	max-width: 510px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	text-align: center;
	align-items: center;
	transition: all 0.1s ease-in-out;

	a {
		&:hover,
		&:active,
		&:focus {
			-webkit-transform: scale(1.1);
			-ms-transform: scale(1.1);
			transform: scale(1.1);
		}
	}

	@media screen and (max-width: 769px) {
		max-width: 100%;
		justify-content: center;
		gap: 1rem;
		flex-wrap: wrap;
	}

	/* Style only direct child SVG icon divs, not nested containers */
	> a > div,
	> div:not(#donate-button-container):not(:has(#paypal-donate-button)) {
		cursor: pointer;
		margin-right: 15px;
		width: 25px;
		height: 25px;

		&:hover {
			fill: var(--color-primary-hover);
		}

		@media screen and (max-width: 769px) {
			margin-right: 0;
		}
	}
`;

export const Language = styled("h4")`
	font-size: 22px;
	text-transform: capitalize;
	color: var(--color-heading);

	@media screen and (max-width: 414px) {
		padding: 1.5rem 0;
	}
`;
